/**
 * URLs de checkout directo.
 * Apuntan directo al checkout del cliente.
 * Para reconectar, pegá nuevamente las URLs de checkout acá.
 */
export const CHECKOUT_URLS = {
  hogarNatural: 'https://hogarnaturalencasa.impultienda.ar/checkout',
  superPack: 'https://hogarnaturalencasa.impultienda.ar/checkout',
} as const
